module.exports = __webpack_public_path__ + "static/media/gt.a89a8c63.svg";